import { storageAvailable } from '../utils';

import ObjectStorage from './ObjectStorage';

class Storage {
    constructor() {
        this.storage = null;
        if (storageAvailable('localStorage')) {
            this.storage = window.localStorage;
        } else if (storageAvailable('sessionStorage')) {
            this.storage = window.sessionStorage;
        } else {
            // Add cookie storage or whatever
            this.storage = new ObjectStorage();
        }

        this.set = this.set.bind(this);
        this.get = this.get.bind(this);
        this.clear = this.clear.bind(this);
    }

    set(key, value = null) {
        this.storage.setItem(key, JSON.stringify(value));
        return value;
    }

    get(key) {
        let value = null;
        try {
            value = JSON.parse(this.storage.getItem(key)) || null;
        } catch (e) {
            // console.log(e);
        }
        return value;
    }

    clear(key) {
        this.storage.setItem(key, null);
        return null;
    }
}

export default Storage;
